import useCheckMobile from './useCheckMobile';

export enum StoreTypes {
  appStore = 1,
  playStore = 2,
}

function getMobileOperatingSystem() {
  const userAgent = navigator.userAgent || navigator.vendor;

  if (/android/i.test(userAgent)) {
    return StoreTypes.playStore;
  }

  if (/iPhone/.test(userAgent)) {
    return StoreTypes.appStore;
  }

  return null;
}

const useRedirectStore = () => {
  const { isMobileSize } = useCheckMobile();
  const storeType = getMobileOperatingSystem();

  switch (storeType) {
    case StoreTypes.appStore:
      if (isMobileSize) {
        window.location.href = process.env?.REACT_APP_APPLE_STORE_URL ?? '';
      }
      break;
    case StoreTypes.playStore:
      if (isMobileSize) {
        window.location.href = process.env?.REACT_APP_PLAY_STORE_URL ?? '';
      }
      break;
    default:
      break;
  }

  return { isMobile: getMobileOperatingSystem() };
};

export default useRedirectStore;
